import http from 'plugins/axios';

export default {
  getWorkPage(data) {
    return http.get({
      url: '/admin/workOrderEn/page',
      data
    });
  },
  updateWork(data) {
    return http.post({
      url: '/admin/workOrderEn/addOrUpdate',
      data
    });
  },
  getTicketDetail(id) {
    return http.get({
      url: `/admin/question/detail/${id}`
    });
  },
  updateWorkStatus({ id, status }) {
    return http.post({
      url: '/admin/workOrderEn/updateStatsu',
      data: {
        id,
        status
      },
      dataType: 'form'
    });
  },
  delWork({ id }) {
    return http.post({
      url: '/admin/workOrderEn/delete',
      data: {
        id
      },
      dataType: 'form'
    });
  }
};
